import { AxiosResponse } from 'axios';
import { axiosInstance } from '..';

export function getListPurchaseOrder(
  filters: {
    centerCodes?: string[],
    groupArticles?: string[],
    statusIds?: number[],
    paymentConditions?: string[],
    withAnticipo?: boolean,
    purchasingGroups?: number[],
    areas?: number[],
    userCodes?: string[],
    emissionDateFrom?: string,
    emissionDateTo?: string,
    hasMaterial?: boolean,
    releaseDateFrom?: string,
    releaseDateTo?: string,
    supplierIds?: number[],
    applicationCodes?: string[],
  },
  search?:string,
  page: number = 1,
  pageSize: number = 10
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();

  params.append('page', page.toString());
  params.append('pageSize', pageSize.toString());

  if (search && search.trim() !== '') {
    params.append('search', search.trim());
  }
  if (filters.centerCodes) {
    filters.centerCodes.forEach(code => params.append('centerCodes', code));
  }
  if (filters.groupArticles) {
    filters.groupArticles.forEach(ga => params.append('groupArticles', ga));
  }
  if (filters.statusIds) {
    filters.statusIds.forEach(id => params.append('statusIds', id.toString()));
  }
  if (filters.paymentConditions) {
    filters.paymentConditions.forEach(pc => params.append('paymentConditions', pc));
  }
  if (filters.withAnticipo !== undefined) {
    params.append('withAnticipo', filters.withAnticipo.toString());
  }
  if (filters.purchasingGroups) {
    filters.purchasingGroups.forEach(pg => params.append('purchasingGroups', pg.toString()));
  }
  if (filters.areas) {
    filters.areas.forEach(area => params.append('areas', area.toString()));
  }
  if (filters.userCodes) {
    filters.userCodes.forEach(uc => params.append('userCodes', uc));
  }
  if (filters.emissionDateFrom) {
    params.append('emissionDateFrom', filters.emissionDateFrom);
  }
  if (filters.emissionDateTo) {
    params.append('emissionDateTo', filters.emissionDateTo);
  }
  if (filters.hasMaterial !== undefined) {
    params.append('hasMaterial', filters.hasMaterial.toString());
  }
  if (filters.releaseDateFrom) {
    params.append('releaseDateFrom', filters.releaseDateFrom);
  }
  if (filters.releaseDateTo) {
    params.append('releaseDateTo', filters.releaseDateTo);
  }
  if (filters.supplierIds) {
    filters.supplierIds.forEach(pg => params.append('supplierIds', pg.toString()));
  }
  if (filters.applicationCodes) {
    filters.applicationCodes.forEach(uc => params.append('applicationCodes', uc));
  }


  return axiosInstance.get(`PurchaseOrder/ListPurchaseOrders`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getPurchaseOrdersServiceBySupplier(supplier_code) {
  return axiosInstance.get(`PurchaseOrder/GetPurchaseOrdersServiceBySupplier/${supplier_code}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getListPurchaseOrderBySupplier(
  supplierId: number,
  statusIds?: number[],
  centerCodes?: string[],
  hasMaterial?: boolean,
  emissionDateFrom?: string,
  emissionDateTo?: string,
  search?: string,
  deliveryDateFrom?: string,
  deliveryDateTo?: string,
  page: number = 1,
  pageSize: number = 10
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();

  if (statusIds) {
    statusIds.forEach(id => params.append('statusIds', id.toString()));
  }

  if (centerCodes) {
    centerCodes.forEach(code => params.append('centerCodes', code));
  }

  if (hasMaterial !== undefined) {
    params.append('hasMaterial', hasMaterial.toString());
  }

  if (emissionDateFrom) {
    params.append('emissionDateFrom', emissionDateFrom);
  }

  if (emissionDateTo) {
    params.append('emissionDateTo', emissionDateTo);
  }

  if (search) {
    params.append('search', search);
  }

  if (deliveryDateFrom) {
    params.append('deliveryDateFrom', deliveryDateFrom);
  }

  if (deliveryDateTo) {
    params.append('deliveryDateTo', deliveryDateTo);
  }


  params.append('page', page.toString());
  params.append('pageSize', pageSize.toString());

  const baseUrl = `PurchaseOrder/PurchaseOrdersBySupplier/${supplierId}`;
  const fullUrl = `${baseUrl}?${params.toString()}`;


  return axiosInstance.get(`PurchaseOrder/PurchaseOrdersBySupplier/${supplierId}`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getAreaPerPosition(positionId): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`PurchaseOrder/GetAreaPerPosition/${positionId}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getCenterCodes(params?: {
  supplierId?: number;
  emissionDateFrom?: string;
  emissionDateTo?: string;
}) {
  const q = new URLSearchParams();
  if (params?.supplierId) q.append('supplierId', params.supplierId.toString());
  if (params?.emissionDateFrom) q.append('emissionDateFrom', params.emissionDateFrom);
  if (params?.emissionDateTo) q.append('emissionDateTo', params.emissionDateTo);

  return axiosInstance.get(`PurchaseOrder/GetCenterCodes`, {
    params: q,
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  });
}

export function getStatusOC(
  supplierId?: number,
  emissionDateFrom?: string,
  emissionDateTo?: string
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();

  if (supplierId) params.append('supplierId', supplierId.toString());
  if (emissionDateFrom) params.append('emissionDateFrom', emissionDateFrom);
  if (emissionDateTo) params.append('emissionDateTo', emissionDateTo);

  return axiosInstance.get(`Status/List`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function AcceptDeniedOC(formData: FormData): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`PurchaseOrder/AcceptDeniedOC`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}


export function getReasonsList(): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Reasons/List`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function UpdatePdfOC(purchaseOrderId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`PurchaseOrder/UpdatePdfOC/${purchaseOrderId}`, null, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getPendingDelivery(supplierIds, categories): Promise<AxiosResponse<any, any>> {
  let url = 'PurchaseOrder/GetPendingDeliverySummary';
  const params: Record<string, string> = {};
  if (supplierIds) params.supplierIds = supplierIds;
  if (categories) params.categories = categories;
  return axiosInstance.get(url, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getUsersCodes(
  emissionDateFrom?: string,
  emissionDateTo?: string
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();

  if (emissionDateFrom) params.append('emissionDateFrom', emissionDateFrom);
  if (emissionDateTo) params.append('emissionDateTo', emissionDateTo);

  return axiosInstance.get(`PurchaseOrder/GetUserCodes`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getApplicationCodes(
  emissionDateFrom?: string,
  emissionDateTo?: string
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();

  if (emissionDateFrom) params.append('emissionDateFrom', emissionDateFrom);
  if (emissionDateTo) params.append('emissionDateTo', emissionDateTo);

  return axiosInstance.get('PurchaseOrder/GetApplicationCodes', {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getPaymentConditions(
  emissionDateFrom?: string,
  emissionDateTo?: string
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();

  if (emissionDateFrom) params.append('emissionDateFrom', emissionDateFrom);
  if (emissionDateTo) params.append('emissionDateTo', emissionDateTo);

  return axiosInstance.get(`PurchaseOrder/GetPaymentConditions`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getGroupsArticle(
  emissionDateFrom?: string,
  emissionDateTo?: string
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();

  if (emissionDateFrom) params.append("emissionDateFrom", emissionDateFrom);
  if (emissionDateTo) params.append("emissionDateTo", emissionDateTo);

  return axiosInstance.get("PurchaseOrder/GetGroupsArticle", {
    params,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
}



export function getAppCode(): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`PurchaseOrder/GetGroupsArticle`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}


export function exportExcelAdmin(
  filters: {
    centerCodes?: string[],
    groupArticles?: string[],
    statusIds?: number[],
    paymentConditions?: string[],
    withAnticipo?: boolean,
    purchasingGroups?: number[],
    areas?: number[],
    userCodes?: string[],
    emissionDateFrom?: string,
    emissionDateTo?: string,
    hasMaterial?: boolean,
    releaseDateFrom?: string,
    releaseDateTo?: string,
    supplierIds?: number[],
    applicationCodes?: string[],
    search?: string  
  }
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();

  if (filters.centerCodes) {
    filters.centerCodes.forEach(code => params.append('centerCodes', code));
  }
  if (filters.groupArticles) {
    filters.groupArticles.forEach(ga => params.append('groupArticles', ga));
  }
  if (filters.statusIds) {
    filters.statusIds.forEach(id => params.append('statusIds', id.toString()));
  }
  if (filters.paymentConditions) {
    filters.paymentConditions.forEach(pc => params.append('paymentConditions', pc));
  }
  if (filters.withAnticipo !== undefined) {
    params.append('withAnticipo', filters.withAnticipo.toString());
  }
  if (filters.purchasingGroups) {
    filters.purchasingGroups.forEach(pg => params.append('purchasingGroups', pg.toString()));
  }
  if (filters.areas) {
    filters.areas.forEach(area => params.append('areas', area.toString()));
  }
  if (filters.userCodes) {
    filters.userCodes.forEach(uc => params.append('userCodes', uc));
  }
  if (filters.emissionDateFrom) {
    params.append('emissionDateFrom', filters.emissionDateFrom);
  }
  if (filters.emissionDateTo) {
    params.append('emissionDateTo', filters.emissionDateTo);
  }
  if (filters.hasMaterial !== undefined) {
    params.append('hasMaterial', filters.hasMaterial.toString());
  }
  if (filters.releaseDateFrom) {
    params.append('releaseDateFrom', filters.releaseDateFrom);
  }
  if (filters.releaseDateTo) {
    params.append('releaseDateTo', filters.releaseDateTo);
  }
  if (filters.supplierIds) {
    filters.supplierIds.forEach(pg => params.append('supplierIds', pg.toString()));
  }
  if (filters.applicationCodes) {
    filters.applicationCodes.forEach(uc => params.append('applicationCodes', uc));
  }
  if (filters.search) {
    params.append('search', filters.search);
  }
  return axiosInstance.get(`PurchaseOrder/ExportExcelAdmin`, {
    params,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  });
}

export function HistoricOCS(
  filters?: {
    emissionDateFrom?: string,
    emissionDateTo?: string,
    search?: string,
    page?: number,
    pageSize?: number
  }
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();

  if (filters?.emissionDateFrom) {
    params.append('emissionDateFrom', filters.emissionDateFrom);
  }

  if (filters?.emissionDateTo) {
    params.append('emissionDateTo', filters.emissionDateTo);
  }

  if (filters?.search) {
    params.append('search', filters.search);
  }

  if (filters?.page) {
    params.append('page', filters.page.toString());
  }

  if (filters?.pageSize) {
    params.append('pageSize', filters.pageSize.toString());
  }

  return axiosInstance.get(`PurchaseOrder/HistoricOCS`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getComplianceIndicator(
  supplierIds?: string,
  categories?: string,
  startDate?: string,
  endDate?: string,
): Promise<AxiosResponse<any, any>> {
  const params: Record<string, string> = {};
  if (supplierIds) params.supplierIds = supplierIds;
  if (categories) params.categories = categories;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  return axiosInstance.get(`PurchaseOrder/ComplianceIndicator`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getAverageDeliveryDays(
  supplierIds?: string,
  categories?: string,
  startDate?: string,
  endDate?: string
): Promise<AxiosResponse<any, any>> {
  const params: Record<string, string> = {};
  if (supplierIds) params.supplierIds = supplierIds;
  if (categories) params.categories = categories;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  return axiosInstance.get(`PurchaseOrder/AverageDeliveryDays`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getQuantityMaterialOrders(
  supplierIds?: string,
  categories?: string,
  startDate?: string,
  endDate?: string
): Promise<AxiosResponse<any, any>> {
  const params: Record<string, string> = {};
  if (supplierIds) params.supplierIds = supplierIds;
  if (categories) params.categories = categories;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  return axiosInstance.get(`PurchaseOrder/QuantityMaterialOrders`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getBilling(
  supplierIds?: string,
  categories?: string,
  startDate?: string,
  endDate?: string
): Promise<AxiosResponse<any, any>> {
  const params: Record<string, string> = {};
  if (supplierIds) params.supplierIds = supplierIds;
  if (categories) params.categories = categories;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  return axiosInstance.get(`PurchaseOrder/Billing`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function UploadActivePivot(positionIds: number[]): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`PurchaseOrder/UploadActivePivot`,
    positionIds.map(id => ({id})),
    {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function GetActiveFalse(
  statusIds?: number[], 
  supplierId?: number,
  emissionDateFrom?: string,
  emissionDateTo?: string
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();
  
  if (statusIds) {
    statusIds.forEach(id => params.append('statusIds', id.toString()));
  }
  
  if (supplierId !== undefined) {
    params.append('supplierId', supplierId.toString());
  }

  if (emissionDateFrom) {
    params.append('emissionDateFrom', emissionDateFrom);
  }

  if (emissionDateTo) {
    params.append('emissionDateTo', emissionDateTo);
  }

  return axiosInstance.get(`PurchaseOrder/GetActiveFalse`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getAreasOrders(
  emissionDateFrom?: string,
  emissionDateTo?: string
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();
  if (emissionDateFrom) params.append("emissionDateFrom", emissionDateFrom);
  if (emissionDateTo) params.append("emissionDateTo", emissionDateTo);

  return axiosInstance.get("PurchaseOrder/ListAreasOrders", {
    params,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
}


export function getPurchasingGroupsAdmin(
  emissionDateFrom?: string,
  emissionDateTo?: string
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();

  if (emissionDateFrom) params.append("emissionDateFrom", emissionDateFrom);
  if (emissionDateTo) params.append("emissionDateTo", emissionDateTo);

  return axiosInstance.get("PurchaseOrder/ListPurchasingGroupsAdmin", {
    params,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
}


export function downloadExcelHistoricOC(
  filters: {
    emissionDateFrom?: string,
    emissionDateTo?: string,
    search?: string
  }
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();

  if (filters.emissionDateFrom) {
    params.append('emissionDateFrom', filters.emissionDateFrom);
  }

  if (filters.emissionDateTo) {
    params.append('emissionDateTo', filters.emissionDateTo);
  }

  if (filters.search) {
    params.append('search', filters.search);
  }

  return axiosInstance.get(`PurchaseOrder/ExcelHistoricOc`, {
    params,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  });
}